import { ApiGetCompanyList, ApiGetLocationList, ApiGetUserCompanyList, ApiGetUserMenuAccess } from "utils/constants/api"
import useFetch from "utils/hooks/useFetch"
import FailModal from "components/modal/FailModal";
import LoadingModal from "components/modal/LoadingModal";
import SuccessModal from "components/modal/SuccessModal";
import ConfirmationModal from "components/modal/ConfirmationModal";
import { ApiResponseStatusUnauthorized, ApiResponseSuccess, EmptyString } from "utils/Constant";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Home(){
    const navigate = useNavigate()

    const{ data: locationList, fetch: getLocationList } = useFetch(ApiGetLocationList)
    const{ data: companyList, fetch: getCompanyList } = useFetch(ApiGetUserCompanyList)
	const { fetch: getUserMenuAccess } = useFetch(ApiGetUserMenuAccess)

    // Modal
    const [failModal, setFailModal] = useState({ isOpen: false, data: {}, message: EmptyString })
	const [loading, setLoading] = useState({isOpen: false})
    const [successModal, setSuccessModal] = useState({ isOpen: false, data: {} })
    const [confirmationModal, setConfirmationModal] = useState({ isOpen: false, data: {} })
    
    const [fileUrl, setFileUrl] = useState(EmptyString)
    const [file, setFile] = useState(EmptyString)

    const companyClick = (companyId, companyName) => {
        localStorage.setItem("CompanyName", companyName)
        localStorage.setItem("CompanyId", companyId)

        fGetUserMenuAccess(companyId).then(() => {
            window.location.href = "/company/dashboard"
        })
    }

    useEffect(() => {
        setLoading({isOpen: true})

        fGetCompanyList().then(() => {
            setLoading({isOpen: false})
        })
    }, [])

    // Api Function
    async function fGetCompanyList(){
        await getCompanyList({
            data: {
                userId: localStorage.getItem("Id")
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){

            }else if(response.status === ApiResponseStatusUnauthorized){
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                            window.location.href = "/login"
                        }
                    },
                    message: response.message
                })
            }else{
                setFailModal({
                    isOpen: true,
                    data: {
                        onSuccess: async () => {
                            setFailModal({isOpen: false})
                        }
                    },
                    message: response.message
                })
            }
        })
    }
    async function fGetUserMenuAccess(paramCompanyId){
        await getUserMenuAccess({
            data: {
                userId: localStorage.getItem("Id"),
                companyId: paramCompanyId
            }
        }).then((response) => {
            if(response.status === ApiResponseSuccess){
                localStorage.setItem("UserAccessMenu", JSON.stringify(response.data))
            }else if(response.status === ApiResponseStatusUnauthorized){
                window.location.href = "/login"
            }
        })
    }

    // Function
    function fLocationClick(locationId, locationName){
        localStorage.setItem("LocationId", locationId)
        localStorage.setItem("LocationName", locationName)
        
        window.location.href = "/location/transaction"
    }

    return(
        <div>
            
            <div className="border rounded-md w-full p-4 shadow-md bg-white">
                <span className="text-2xl font-semibold">Company</span>
                <hr />
                <div className="mt-4 flex flex-wrap gap-4 justify-center sm:justify-start">
                    { companyList?.data?.userCompany?.map((data, i) => {
                        return(
                            <button className="flex flex-col border rounded-md w-full sm:w-[320px] p-2 bg-white hover:shadow-md transition-all" key={ i } onClick={() => { companyClick(data.companyId, data.companyName) }}>
                                <div className="flex flex-col gap-4 items-center w-full px-2 py-2">
                                    <span className="font-semibold">{ data.companyName }</span>
                                    {/* <span>{ data.address + " " + data.city }</span> */}
                                </div>
                            </button>
                        )
                    })

                    }
                    
                </div>
                
            </div>

            {/* Modal */}
			{failModal.isOpen && ( <FailModal onClose={() => setFailModal({ isOpen: false, data: {}, message: EmptyString })} data={failModal?.data} message={failModal?.message} /> )}
			{loading.isOpen && (<LoadingModal onClose={() => setLoading({ isOpen: false })} />)}
            {successModal.isOpen && ( <SuccessModal onClose={() => setSuccessModal({ isOpen: false, data: {} })} data={successModal?.data} /> )}
            {confirmationModal.isOpen && ( <ConfirmationModal onClose={() => setConfirmationModal({ isOpen: false, data: {} })} data={confirmationModal?.data} /> )}
        </div>
    )
}